// Generated by CoffeeScript 1.9.2
module.exports = function(q) {
  if (typeof q !== 'object') {
    return false;
  }
  return (q != null ? q.__q : void 0) != null;
};
